export enum ContractStatus {
  Draft = 0,
  NewRequest = 5,
  Pending = 10,
  Signed = 15,
  Rejected = 20,
}
